import { Stack, Text } from '@mantine/core';
import type { NavbarItemProps } from './NavbarItem';
import classes from './NavbarItemMobile.module.css';
export const NavbarItemMobile: React.FC<NavbarItemProps> = ({
  icon,
  label,
  href,
  handleItemClick
}) => {
  return label !== 'SEPARATOR' ? <Stack justify="center" align="center" gap={5} classNames={classes} component="a" onClick={() => handleItemClick?.(href || '')}>
      {icon}
      <Text fz={10} fw={700} tt="uppercase" style={{
      textWrap: 'nowrap'
    }} c="var(--text-dark)">
        {label}
      </Text>
    </Stack> : null;
};